export const _onlyNumbersRegExp = /^[\d]*$/;
export const _decimalNumber = /^\d*[\.\,]?\d*$/;
